import { SERVER_API } from 'SharedDir/constants/app/endpoints';

export const deerMeatSaleUrl = `${SERVER_API}/ttp-registries/deer-meat-sales`;
